import React from 'react'

/**
 * @param {{ status?: string | null }} props
 */
export default function CronStatusChip({ status }) {
  const s = (status || '').toLowerCase()
  let variant = 'neutral'
  let label = status || 'Unknown'

  if (s === 'succeeded' || s === 'success') {
    variant = 'success'
    label = 'Success'
  } else if (s === 'running' || s === 'active') {
    variant = 'running'
    label = 'Running'
  } else if (s === 'failed' || s === 'error') {
    variant = 'error'
    label = 'Failed'
  } else if (!status) {
    label = 'No runs yet'
  }

  return <span className={`overview-cron-chip overview-cron-chip--${variant}`}>{label}</span>
}
